import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLinebreak: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="linebreak,next-line"><path d="M3.75 12H16.875C18.877 12 20.5 13.623 20.5 15.625C20.5 17.627 18.877 19.25 16.875 19.25H12.1832" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 19.25H7.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 4.75H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M14.25 16.75L11.75 19.25L14.25 21.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconLinebreak;
